<template>
  <div>
    <div class="pl-2">
      <a class="caption" @click="showDialog">How do my customers find this?</a>
    </div>

    <v-dialog
      v-model="enabled"
      @keydown.esc.prevent="closeDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @input="v => v || closeDialog"
      lazy
      max-width="940px"
      scrollable
    >
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>Useful ACH Information</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon flat color="primary" @click.native="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="primary"></v-divider>

        <v-card-text class="text-xs-center" fill-height>
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 sm6>
              <v-img src="/static/ach_info/check.png"></v-img>
            </v-flex>
            <v-flex xs12 sm6>
              <v-img src="/static/ach_info/app.png"></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'

export default {
  data: function () {
    return {
      enabled: false
    }
  },

  beforeDestroy () {
    Bus.$off('closeDialog')
  },

  mounted () {
    Bus.$on('closeDialog', this.closeDialog)
  },

  methods: {
    async showDialog () {
      try {
        this.enabled = true
      } catch (err) {
        Bus.$emit('openDialog', {
          status: 'error',
          message: err
        })
      }
    },

    closeDialog () {
      Bus.$emit('optionsClose')
      this.enabled = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/help/AchFindInfoDialog.vue